import React from 'react';
import { RootLayout } from 'common/components';
import { OldBathroom } from './old-bathroom';
import { BATHROOM_PATH } from './bathroom-constants';

/**
 * Вью страницы "Ванные комнаты"
 */
export const Bathroom: React.FC = () => (
  <RootLayout currentPage={BATHROOM_PATH}>
    <OldBathroom />
  </RootLayout>
);
